import * as XLSX from "xlsx";
import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const TrainingMOV = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const { sendRequest: getTrainingMOVData } = useHttp();
  const [loading, setLoading] = useState(false);

  const fillTrainingMOVData = (
    employeeId,
    // stateName,
    // farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/trainingMOVReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getTrainingMOVData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillTrainingMOVData(0, 0, "");
  }, [getTrainingMOVData]);

const processFileUrl = (url) =>
    url ? `${process.env.REACT_APP_FILE_URL}${url}` : "";

  const fieldsToExport = [
    "venue",
    "trainingType",
    "attendeeName",
    "gender",
    "mobileNumber",
    "signature",
    "image",
  ];

  const customHeaders = [
    "Training Location",
    "Training Type",
    "Attendee names",
    "Gender",
    "Mobile Number",
    "Attendee Signature",
    "Picture captured",
  ];

  const handleExportExcel = () => {
    setLoading(true);
    const filename = "TrainingMOV.xlsx";
  
    if (!data || data.length === 0) {
      console.error("No data available for export.");
      setLoading(false);
      return;
    }
  
    const getDownloadUrl = (path) => {
      if (!path) return "";
      const base = process.env.REACT_APP_FILE_URL || "";
      return `${base}${path}`;
    };
  
    const headers = [
      "Promoter Id",
      "Agri Promoter Name",
      "Doc No",
      "Training Date",
      "State",
      "LGA",
      "Village Name",
      "Demo Location",
      "Training Topic",
      "Training Id",
      "Training Location",
      "Training Type",
      "Attendee Names",
      "Gender",
      "Mobile Number",
      "Frequency Of Training To Farmer",
      "Attendee Signature",
      "Picture Captured",
    ];
  
    const rows = data.map((item, index) => {
      const signatureUrl = getDownloadUrl(item.signature);
      const imageUrl = getDownloadUrl(item.image);
  
      return [
        item.employeeCode || "",
        item.employeeName || "",
        item.docNo || "",
        item.trainingDate || "",
        item.state || "",
        item.lga || "",
        item.villageName || "",
        item.demoLocation || "",
        item.topic || "",
        item.trainingDetailId || "",
        item.venue || "",
        item.trainingType || "",
        item.attendeeName || "",
        item.gender || "",
        item.mobileNumber || "",
        item.frequencyOfTrainingToFarmer|| "",
        signatureUrl || "No Signature",
        imageUrl || "No Image",
      ];
    });
  
    const sheetData = [headers, ...rows];
  
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Training MOV");
  
    try {
      XLSX.writeFile(workbook, filename);
    } catch (err) {
      console.error("Excel export failed:", err);
    } finally {
      setLoading(false);
    }
  };
  
  
  
  
  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
                Training MOV Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value !== "0") userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillTrainingMOVData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
            <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={handleExportExcel}
                disabled={loading}
              >
                {loading ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-file-excel"></i>
                )}
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          <th>Doc No</th>
                          <th>Training Date</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Village Name</th>
                          <th>Demo Location</th>
                          <th>Training Topic</th>
                          <th>Subject</th>
                          <th>Training Id</th>
                          <th>Training Location</th>
                          <th>Training Type</th>
                          <th>Attendee names</th>
                          <th>Gender</th>
                          <th>Mobile Number</th>
                          <th>Frequency Of Training To Farmer</th>
                          <th>Attendee Signature</th>
                          <th>Picture captured</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>{itm.employeeCode}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.docNo}</td>
                                <td>{itm.trainingDate}</td>
                                <td>{itm.state}</td>
                                <td>{itm.lga}</td>
                                <td>{itm.villageName}</td>
                                <td>{itm.demoLocation}</td>
                                <td>{itm.topic}</td>
                                <td>{itm.subject}</td>
                                <td>{itm.trainingDetailId}</td>
                                <td>{itm.venue || ""}</td>
                                <td>{itm.trainingType || ""}</td>
                                <td>{itm.attendeeName || ""}</td>
                                <td>{itm.gender || ""}</td>
                                <td>{itm.mobileNumber || ""}</td>
                                <td>{itm.frequencyOfTrainingToFarmer}</td>
                                <td>
                                  {itm.signature ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.signature}`}
                                      alt="Signature"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Signature"
                                  )}
                                </td>

                                <td>
                                  {itm.image ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.image}`}
                                      alt="Farmer"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TrainingMOV;
